import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Query } from '../op-types';

export function createFinnhubQueries(client: StoxlyClient) {
  return createQueryKeys('finnhub', {
    // ['finnhub', 'detail', symbol, ...]
    detail: (symbol: string) => ({
      queryKey: [symbol],
      contextQueries: {
        etfBondData: {
          queryKey: null,
          queryFn: ({ signal }) => client.finnhubEtfGetEtfBondData({ params: { symbol }, signal }),
        },
        etfCountryExposure: {
          queryKey: null,
          queryFn: ({ signal }) =>
            client.finnhubEtfGetEtfCountryExposure({ params: { symbol }, signal }),
        },
        etfHoldings: {
          queryKey: null,
          queryFn: ({ signal }) => client.finnhubEtfGetEtfHoldings({ params: { symbol }, signal }),
        },
        etfFundPerformance: {
          queryKey: null,
          queryFn: ({ signal }) =>
            client.finnhubEtfGetEtfFundPerformance({ params: { symbol }, signal }),
        },
        etfProfile: {
          queryKey: null,
          queryFn: ({ signal }) => client.finnhubEtfGetEtfProfile({ params: { symbol }, signal }),
        },
        etfSectorExposure: {
          queryKey: null,
          queryFn: ({ signal }) =>
            client.finnhubEtfGetEtfSectorExposure({ params: { symbol }, signal }),
        },
        earnings: (query?: Query<'finnhubFinancialsGetEarnings'>) => ({
          queryKey: [{ query }],
          queryFn: ({ signal }) =>
            client.finnhubFinancialsGetEarnings({ params: { symbol }, queries: query, signal }),
        }),
      },
    }),
  });
}
